import angular from 'angular';

let infiniteScroll = angular
    .module("infiniteScroll", []);

export default infiniteScroll;